import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

import {Comment, User, UserLevels, UserService} from '../core';
import {Subscription} from 'rxjs';
import AssetsUtil from '../core/utils/assets.util';

@Component({
  selector: 'app-deal-comment',
  templateUrl: './deal-comment.component.html'
})
export class DealCommentComponent implements OnInit, OnDestroy {
  constructor(
      private userService: UserService
  ) {}

  private subscription: Subscription;

  @Input() comment: Comment;
  @Output() deleteComment = new EventEmitter<boolean>();
  @Output() editComment = new EventEmitter<boolean>();

  canModify: boolean;
  imageFallback = AssetsUtil.loadAvatarFallbackOnError();
  isSubmitting = false;

  ngOnInit() {
    // Load the current user's data
    this.subscription = this.userService.currentUser.subscribe(
        (userData: User) => {
          this.canModify = (userData.username === this.comment.comment_user_name) ||
              userData.level === UserLevels.Admin ||
              userData.level === UserLevels.Moderator;
        }
    );
  }

  getAvatarImage() {
    return AssetsUtil.get_big_avatar_url(this.comment.comment_user_id);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  deleteClicked() {
    this.deleteComment.emit(true);
  }
  editClicked() {
    this.comment.isEditing = !this.comment.isEditing;
  }
  commentEdited() {
    this.editComment.emit(true);
  }
}
